import { useMtmColumnStore } from '@/stores';
import { useMtmCrossDnd, addSidebarPrefix } from './MtmCrossDndContext';
import { createColumnManagerPanel } from '@/components/shared/createColumnManagerPanel';
import type { CreateColumnManagerPanelConfig } from '@/components/shared/createColumnManagerPanel';

export const MtmColumnManagerPanel = createColumnManagerPanel({
  useColumnStore: useMtmColumnStore as CreateColumnManagerPanelConfig['useColumnStore'],
  useCrossDnd: useMtmCrossDnd,
  addSidebarPrefix,
});
